import { render, staticRenderFns } from "./i4pro-carousel.vue?vue&type=template&id=5ee5e9e9&scoped=true"
import script from "./i4pro-carousel.vue?vue&type=script&lang=js"
export * from "./i4pro-carousel.vue?vue&type=script&lang=js"
import style0 from "./i4pro-carousel.vue?vue&type=style&index=0&id=5ee5e9e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee5e9e9",
  null
  
)

export default component.exports